<template>
  <div>
    <div class="tile is-parent pl-1">
      <article class="tile is-child box">
        <div class="columns is-flex is-align-items-center">
          <div class="column">
            <p class="title">Profile</p>
          </div>
        </div>

        <div class="field columns">
          <div class="column is-half">
            <label class="label">Company</label>
            <div class="control">
              <multiselect v-model="selectedCompany"
                deselect-label="Can't remove this value"
                track-by="companyId"
                label="name"
                placeholder="Search By Name..."
                :options="companies"
                :loading="isCompaniesLoading"
                :internal-search="false"
                :searchable="true"
                :show-labels="false"
                :allow-empty="true"
                :disabled="true">
                <template slot="option"
                  slot-scope="props">
                  <span>{{ props.option.name }}</span>
                </template>
                <span class="has-text-danger"
                  slot="noResult">Company not found.</span>
              </multiselect>
            </div>
          </div>
          <div class="column is-half">
            <label class="label">Salutation</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="value.profile.salutation">
                  <option value="null"
                    disabled>Select</option>
                  <option v-for="(name, code) in salutes"
                    :key="code"
                    :value="name">
                    {{ name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="field columns">
          <div class="column is-half">
            <label class="label">First Name</label>
            <div class="control">
              <input class="input"
                type="text"
                v-model="value.profile.firstName">
            </div>
          </div>
          <div class="column is-half">
            <label class="label">Last Name</label>
            <div class="control">
              <input class="input"
                type="text"
                v-model="value.profile.lastName">
            </div>
          </div>
        </div>
        <div class="field columns">
          <div class="column is-half">
            <label class="label">Display Name</label>
            <div class="control">
              <input class="input"
                type="text"
                v-model="value.profile.displayName">
            </div>
          </div>
          <div class="column is-half">
            <label class="label">Gender</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="value.profile.sex">
                  <option value="null"
                    disabled>Select</option>
                  <option v-for="(name, code) in sex"
                    :key="code"
                    :value="code">
                    {{ name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="field columns">
          <div class="column is-half">
            <label class="label">Date of Birth</label>
            <v-date-picker v-model="selectedDOBDate"
              :is-dark="$theme.isDark"
              :masks="formats"
              :attributes="attrs"
              :locale="$userInfo.locale"
              @input="dobDateInputEvent"
              :timezone="$filters.getIanaTimezone()">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field">
                  <div class="control has-icons-left">
                    <input type="text"
                      class="input"
                      placeholder="Date of Birth"
                      :value="inputValue"
                      v-on="inputEvents"
                      readonly>
                    <span class="icon is-small is-left">
                      <span class="mso mso-18px">
                        event
                      </span>
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
        </div>
        <div class="field">
          <user-asset-addresses ref="assetAddresses"
            :addresses="activeAddresses"
            :country-code="countryCode"
            :required="false"
            @removeAddress="removeAddress"
            @setDefault="setDefault"
            @addTmpAddress="addTmpAddress" />
        </div>
        <div class="field">
          <user-asset-phones ref="assetPhones"
            :phones="activePhones"
            :required="false"
            @removePhone="removePhone"
            @setDefault="setDefault"
            @addTmpPhone="addTmpPhone" />
        </div>
        <div class="field">
          <user-asset-emails ref="assetEmails"
            :emails="activeEmails"
            :required="false"
            @removeEmail="removeEmail"
            @setDefault="setDefault"
            @addTmpEmail="addTmpEmail" />
        </div>
        <div class="field columns mb-2">
          <div class="column is-half">
            <user-contacts ref="userContacts"
              :contacts="activeContacts"
              :company-id="innerValue.profile.companyId"
              @addContact="addContact"
              @setDefault="setDefault"
              @removeContact="removeContact"
              @updateContacts="updateContacts" />
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import _cloneDeep from 'lodash.clonedeep'
import { AddressTypes, Salutation, Gender } from '@/enums'
import { CompanyService } from '../../services'
import { DateTimeFiltersMixin } from '@/components/mixins/filters'
import Multiselect from 'vue-multiselect'
import Guid from '@/components/Guid'
import UserAssetAddresses from './assets/UserAssetAddresses.vue'
import UserAssetPhones from './assets/UserAssetPhones.vue'
import UserAssetEmails from './assets/UserAssetEmails.vue'
import UserContacts from './assets/UserContacts.vue'
// import ContactService from '../contact/ContactService'
import { AddressModel, EmailModel, PhoneModel } from '../../classes/viewmodels'

export default {
  name: 'UserProfile',
  inject: ['$vv'],
  components: {
    Multiselect,
    UserAssetAddresses,
    UserAssetPhones,
    UserAssetEmails,
    UserContacts
  },
  mixins: [DateTimeFiltersMixin],
  props: {
    value: null //v-model
  },
  data() {
    return {
      innerValue: null,
      selectedDOBDate: null,
      address: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        data: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        dayPopover: 'L'
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff8080'
          },
          popover: {
            label: 'Today'
          },
          dates: new Date()
        }
      ],
      addresses: {
        data: [],
        loading: false
      },
      isCompaniesLoading: false,
      companies: [],
      selectedCompany: null
    }
  },
  computed: {
    addressTypes() {
      return AddressTypes
    },
    salutes() {
      return Salutation
    },
    sex() {
      return Gender
    },
    activeAddresses() {
      if (this.innerValue.profile && this.innerValue.profile.assetAddresses) {
        return [...this.innerValue.profile.assetAddresses].filter((a) => !a.isDeleted)
      }
    },
    activePhones() {
      if (this.innerValue.profile && this.innerValue.profile.assetPhones) {
        return [...this.innerValue.profile.assetPhones].filter((a) => !a.isDeleted)
      }
    },
    activeEmails() {
      if (this.innerValue.profile && this.innerValue.profile.assetEmails) {
        return [...this.innerValue.profile.assetEmails].filter((a) => !a.isDeleted)
      }
    },
    countryCode() {
      if (this.activeAddresses && this.activeAddresses.length > 0) {
        var address = this.activeAddresses.find((a) => a.isDefault)
        if (address) {
          return address.countryCode
        }
        return this.activeAddresses[0].countryCode
      }
      return this.$company.info.countryCode
    },
    activeContacts() {
      return this.innerValue.profile.contacts.filter((c) => c.contact.isActive)
    },
    $entity() {
      if (this.$v.entity) {
        // From route view
        return this.$v.entity
      } else {
        // From component tab
        return this.$v
      }
    },
    $v() {
      return this.$vv
    }
  },
  watch: {
    innerValue: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    selectedDOBDate: function (newVal, oldVal) {
      if (newVal) {
        this.innerValue.profile.dob = newVal.toISOString().split('.')[0] + 'Z'
      } else {
        this.innerValue.profile.dob = null
      }
    }
  },
  created() {
    this.innerValue = _cloneDeep(this.value)
    if (this.innerValue.profile.dob) {
      this.selectedDOBDate = new Date(`${this.innerValue.profile.dob}`)
    }
    this.address = {
      type: '0',
      address1: '',
      suburbText: '',
      stateCode: '',
      suburbPostcode: '',
      countryText: ''
    }
    this.getCompanyDropdown()
    // this.innerValue.profile.assetAddresses = this.activeAddresses
  },
  mounted() {
    this.$on('refreshProfile', (newEntity) => {
      this.innerValue = _cloneDeep(newEntity)
    })
    // Touch validation for addresses, phones, emails
    if (this.$v.entity) {
      if (this.$v.entity.addresses) {
        this.$v.entity.addresses.$touch()
      }
      if (this.$v.entity.phones) {
        this.$v.entity.phones.$touch()
      }
      if (this.$v.entity.emails) {
        this.$v.entity.emails.$touch()
      }
      this.$v.profileAddressesGroup.$touch()
      this.$v.profilePhonesGroup.$touch()
      this.$v.profileEmailsGroup.$touch()
    }
  },
  methods: {
    dobDateInputEvent(event) {
      this.selectedDOBDate = this.$filters.fromISOWithCurrentTime(event.toISOString())
    },
    async getCompanyDropdown() {
      this.isCompaniesLoading = true
      this.companies = await CompanyService.getAllCompanies()
      if (this.innerValue.profile.companyId !== Guid.empty()) {
        this.selectedCompany = this.companies.find((c) => c.companyId === this.innerValue.profile.companyId)
      }
      this.isCompaniesLoading = false
    },
    removeAddress(address) {
      const idx = this.innerValue.profile.assetAddresses.findIndex((a) => a === address)
      if (idx !== -1) {
        if (!address.isNew && address.id) {
          this.innerValue.profile.assetAddresses[idx].isDeleted = true
        } else {
          this.innerValue.profile.assetAddresses.splice(idx, 1)
        }
      }
    },
    removePhone(phone) {
      const idx = this.innerValue.profile.assetPhones.findIndex((a) => a === phone)
      if (idx !== -1) {
        if (!phone.isNew && phone.id) {
          this.innerValue.profile.assetPhones[idx].isDeleted = true
        } else {
          this.innerValue.profile.assetPhones.splice(idx, 1)
        }
      }
    },
    removeEmail(email) {
      const idx = this.innerValue.profile.assetEmails.findIndex((a) => a === email)
      if (idx !== -1) {
        if (!email.isNew && email.id) {
          this.innerValue.profile.assetEmails[idx].isDeleted = true
        } else {
          this.innerValue.profile.assetEmails.splice(idx, 1)
        }
      }
    },
    setDefault(asset, assetType) {
      this.innerValue.profile[assetType].forEach((a) => (a.isDefault = a == asset))
    },
    addTmpAddress() {
      let newAddress = new AddressModel(this.innerValue.profile.companyId)
      if (this.innerValue.profile.assetAddresses.length == 0) {
        newAddress.isDefault = true
      }
      this.innerValue.profile.assetAddresses.push(newAddress)
    },
    addTmpPhone() {
      let newPhone = new PhoneModel()
      if (this.innerValue.profile.assetPhones.length == 0) {
        newPhone.isDefault = true
      }
      this.innerValue.profile.assetPhones.push(newPhone)
    },
    addTmpEmail() {
      let newEmail = new EmailModel()
      if (this.innerValue.profile.assetEmails.length == 0) {
        newEmail.isDefault = true
      }
      this.innerValue.profile.assetEmails.push(newEmail)
    },
    async addContact(newContact) {
      this.innerValue.profile.contacts.push(newContact)
    },
    removeContact(contact) {
      const idx = this.innerValue.profile.contacts.findIndex((c) => c.id === contact.id)
      if (idx !== -1) {
        if (!contact.isNew && contact.id) {
          this.innerValue.profile.contacts[idx].isDeleted = true
          this.innerValue.profile.contacts[idx].contact.isActive = false
        } else {
          this.innerValue.profile.contacts.splice(idx, 1)
        }
      }
    },
    updateContacts(updatedContacts) {
      this.innerValue.profile.contacts = updatedContacts
    }
  },
  beforeRouteLeave: function (to, from, next) {
    next()
  }
}
</script>
